import React, {useContext, useEffect} from 'react';
import {StoreContext} from '../base/root-store';
import {observer} from 'mobx-react-lite';
import {
    IChatAnswerProps,
    IChatMessageProps,
    IChatReplyFormProps,
    Notification,
    TChatItem,
    TemplateChat,
} from '../../../patterns';
import {formatToDayMonthAndYear} from '../base/dateUtils';
import {GenericError} from '../base/GenericError';
import {MentorContext, MentorMessage, MentorStore} from './mentor-store';


export const MentorPage = observer((props: {loadContext?: MentorContext, isNotFromQuestion?: boolean}): JSX.Element => {
    const store = useContext(StoreContext).mentorStore;

    useEffect(() => {
        if (props.loadContext === 'history') {
            store.onEnter();
        }
    }, []);

    if (store.state === 'error' && store.errorReason === 'generic') {
        return <GenericError/>;
    }
    if (store.state === 'error' && store.errorReason === 'user-deleted') {
        return <Notification
            text={store.label('common.user.deleted.error-message')}
            defaultIsOpen={true}
            type="info"
        />;
    }
    if (store.state === 'loading') {
        return <TemplateChat chat={{
            isLoading: true,
            isMentorChat: true,
        }}/>;
    }

    const items: TChatItem[] = store.variables.deliveredMessages
        .map((message) => message.party === 'mentor' ? messageProps(message) : answerProps(message));

    return <TemplateChat chat={{
        items,
        isLoading: store.getBotTyping(),
        isMentorChat: true,
        reply: replyButtonsProps(store),
    }}/>;
});

const messageProps = (message: MentorMessage): IChatMessageProps => ({
    element: 'message',
    message: message.text,
    hasClickableUrl: message.hasClickableUrl,
    time: {
        iso: message.date,
        value: formatToDayMonthAndYear(message.date),
    },
    conversationId: message.conversationId,
});

const answerProps = (message: MentorMessage): IChatAnswerProps => ({
    element: 'answer',
    text: message.text,
    color: undefined,
    time: {
        iso: message.date,
        value: formatToDayMonthAndYear(message.date),
    },
});

const replyButtonsProps = (store: MentorStore): IChatReplyFormProps | undefined => {
    if (store.getBotTyping() || store.variables.actions === undefined) {
        return undefined;
    } else {

        return {
            textField: {
                id: 'mentor-ask-form',
                name: 'mentor-ask-form',
                defaultValue: '',
                label: '',
                onChange: (value): void => store.onFollowUpChange(value),
            },
            actions: store.variables.actions.map((choice) => ({
                text: choice.text,
                color: choice.color,
                onClick: async (): Promise<void> => await store.onSubmitFollowUpQuestion(choice.value),
            })),
        } as IChatReplyFormProps;
    }
};
